import {map, of, tap} from 'rxjs';

import {computed, inject} from '@angular/core';
import {signalStore, withComputed, withHooks, withMethods, withState} from '@ngrx/signals';
import {
	DEFAULT_SIGNAL_STORE_CONFIG,
	getSignalStoreNameToken,
	initialStateOf,
	SignalStoreStateStructure,
	withDevtools,
	withGetState,
	withMetaData,
	withStateValidator,
	withSyncableState,
	withUpdateState,
} from '@shared/signal-store';

import {MetaTagsService} from '../services';

export const META_TAGS_SINGAL_STORE_NAME = getSignalStoreNameToken('MetaTagsStore');
export const metaTagsStoreInitState = initialStateOf(META_TAGS_SINGAL_STORE_NAME);
type MetaTagsStoreState = SignalStoreStateStructure<typeof META_TAGS_SINGAL_STORE_NAME>;

export const MetaTagsSignalStore = signalStore(
	DEFAULT_SIGNAL_STORE_CONFIG,
	withState(metaTagsStoreInitState),
	withMetaData({StoreName: META_TAGS_SINGAL_STORE_NAME}),
	withDevtools(META_TAGS_SINGAL_STORE_NAME),
	withSyncableState(),
	withStateValidator(),
	withUpdateState(),
	withGetState<MetaTagsStoreState>(),
	withComputed(state => ({
		selectMetaTags: state.metaTags,
		selectEnabledMetaTags: computed(() => state.metaTags()?.filter(metaTag => metaTag.isEnabled)),
	})),
	withMethods((state, metaTagsService: MetaTagsService = inject(MetaTagsService)) => ({
		loadMetaTags: (containsDisables = false) => {
			if (state.metaTags() !== null && state.loaded()) return of(state.metaTags());
			state.updateState(
				{
					loading: true,
				},
				'Loading Meta Tags',
			);
			return metaTagsService.getMetaTagKeys().pipe(
				map(metaTags => metaTags.filter(metaTag => containsDisables || metaTag.isEnabled)),
				tap(metaTags => {
					state.updateState(
						{
							metaTags,
							loaded: true,
							loading: false,
						},
						'Meta Tags Loaded',
					);
				}),
			);
		},
	})),

	withHooks(state => ({
		onInit: () => {
			state.loadMetaTags().subscribe();
		},
		onDestroy: () => {
			// Cleanup
		},
	})),
);
